import { Box, CircularProgress } from "@material-ui/core";
import DrilldownScatterChart from "./DrilldownScatterChart";
import useDrilldownSeries from "../../../hooks/charts/useDrilldownSeries";

export default function DrilldownScatterChartContainer({
  parameterid,
  startDate,
  endDate,
  season,
  locationIds,
  height = 400,
}) {
  const { seriesByLoc, unit, parameter, isLoading, isError } =
    useDrilldownSeries({
      parameterid,
      startDate,
      endDate,
      season,
      locationIds,
    });

  if (isLoading) {
    return (
      <Box
        height={height}
        display="flex"
        alignItems="center"
        justifyContent="center"
      >
        <CircularProgress />
      </Box>
    );
  }

  if (isError || !Object.keys(seriesByLoc).length) {
    return (
      <Box
        height={height}
        display="flex"
        alignItems="center"
        justifyContent="center"
      >
        No data
      </Box>
    );
  }

  return (
    <DrilldownScatterChart
      seriesByLoc={seriesByLoc}
      unit={unit}
      parameter={parameter}
      height={height}
      season={season}
    />
  );
}
